<template>
  <div class="noticeList">
    <p
      class="record"
      v-html="$t('other.w78').replace('{%}',totalCount).replace('{%}',UnreadInfoCount)"
    ></p>
    <div class="operate">
      <span class="active" @click="setting">通知设置</span>
      <span @click="allread">{{$t('btn.b37')}}</span>
      <span @click="del">{{$t('btn.b25')}}</span>
    </div>
    <p class="color-blue">{{$t('other.w79').replace('{%}',checkedunreadList.length)}}</p>
    <div class="table">
      <Datatable
        url="/Member/RZJInfoCenter/UserInfoList"
        field="UserInfoList"
        @on-data="ondata"
        ref="Datatable"
        :colcount="4"
        :tip="$t('msg.m119')"
      >
        <tr slot="th">
          <th width="20">
            <Checkbox v-model="allChecked" @on-change="allCheck" />
          </th>
          <th width="220">{{$t('label.w122')}}/{{$t('label.w123')}}</th>
          <th>{{$t('label.w124')}}</th>
          <th width="60"></th>
        </tr>
        <template v-slot="{item}">
          <tr class="item" @click="switchContent(item)">
            <td @click.stop>
              <Checkbox v-model="item.checked" @on-change="itemCheck(item)" />
            </td>
            <td>
              <div class="author" :class="{unread:item.State===0}">{{$t('other.w80')}}</div>
              <div class="time">{{item.CreatedAt}}</div>
            </td>
            <td>{{item.Subject}}</td>
            <td>
              <Icon type="ios-arrow-forward" v-show="!item.contentShow" color="#9BA3B2" size="18" />
              <Icon type="ios-arrow-down" v-show="item.contentShow" color="#9BA3B2" size="18" />
            </td>
          </tr>
          <tr v-show="item.contentShow">
            <td colspan="4" class="detailtd">
              <div class="content" v-html="item.Content"></div>
            </td>
          </tr>
        </template>
      </Datatable>
    </div>
    <Setting ref="Setting" />
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import Setting from "./modal/setting";
export default {
  components: { Datatable, Setting },
  data() {
    return {
      type: 1,
      allChecked: false,
      list: [],
      UnreadInfoCount: 0,
      totalCount: 0
    };
  },
  methods: {
    switchContent(item) {
      if (item.State === 0) {
        item.State = 1;
        this.$store.commit("user/unreadCount", "-");
        this.UnreadInfoCount--;
        this.$axios.post("/Member/RZJInfoCenter/ReadUserInfo", {
          userInfoId: item.Id
        });
      }
      this.$set(item, "contentShow", !item.contentShow);
    },
    ondata(v) {
      console.log(v);
      this.allChecked = false;
      this.list = v.UserInfoList || [];
      this.UnreadInfoCount = v.UnreadInfoCount || 0;
      this.totalCount = v.Pager ? v.Pager.TotalCount : 0;
    },
    itemCheck(item) {
      for (let i = 0; i < this.list.length; i++) {
        if (!this.list[i].checked) {
          this.allChecked = false;
          return;
        }
      }
      this.allChecked = true;
    },
    allCheck() {
      for (let i = 0; i < this.list.length; i++) {
        this.$set(this.list[i], "checked", this.allChecked);
      }
    },
    async allread() {
      if (!this.UnreadInfoCount) return this.$Message.error(this.$t("msg.m46"));
      let res = await this.$axios.post("/Member/RZJInfoCenter/AllReadUserInfo");
      res.throw();
      this.$store.commit("user/unreadCount", 0);
      if (!res.err) {
        this.$refs.Datatable.refresh();
      }
    },
    async del() {
      if (!this.checkedList.length)
        return this.$Message.error(this.$t("msg.m47"));
      let res = await this.$axios.post("/Member/RZJInfoCenter/DeleteUserInfo", {
        userInfoIds: this.checkedList.map(v => v.Id).join(",")
      });
      res.throw();
      if (!res.err) {
        this.$refs.Datatable.refresh();
        this.$store.dispatch("user/getUser");
      }
    },
    setting() {
      this.$refs.Setting.getdata();
      this.$refs.Setting.modal = true;
    }
  },
  computed: {
    checkedList() {
      return this.list.filter(v => v.checked);
    },
    checkedunreadList() {
      return this.list.filter(v => v.checked && v.State === 0);
    }
  }
};
</script>

<style lang="less" scoped>
td,
th {
  text-align: left !important;
  &:first-child {
    padding-left: 20px !important;
    padding-right: 0;
  }
}
.item {
  cursor: pointer;
  td {
    padding-top: 15px;
    padding-bottom: 15px;
    .author {
      &.unread:before {
        content: "";
        width: 5px;
        height: 5px;
        display: inline-block;
        background: #5e8ffc;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
    .time {
      color: #7b7b7c;
      font-size: 12px;
    }
  }
}
.detailtd {
  background: rgba(233, 234, 238, 1);
  line-height: 20px;
  box-shadow: inset 0px 30px 15px -20px rgba(0, 0, 0, 0.1);
  .content {
    padding: 10px 0 10px 35px;
  }
}
.text-left {
  text-align: left !important;
}
th {
  padding-left: 15px;
}
.noticeList {
  color: #7b7b7c;
  font-size: 14px;
  min-height: 600px;
  /deep/ .color-b {
    color: #232325;
  }
  /deep/ .color-blue {
    color: #5e8ffc;
  }
  .record {
    margin-bottom: 30px;
    /deep/ span {
      margin: 0 3px;
    }
    /deep/ .s1 {
      font-weight: 550;
    }
  }
  .operate {
    margin-bottom: 20px;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      font-weight: 500;
      margin-right: 20px;
      cursor: pointer;
      border-radius: 8px;
      border: 1px solid rgba(151, 151, 151, 1);
    }
    .haveread {
      margin-right: 14px;
    }
    .active {
      background: rgba(94, 143, 252, 1);
      color: #fff;
      border: 0;
    }
  }
}
</style>
